import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useEnableV3SearchAPI = () => {
  const { data: config } = useInstanceConfigQuery();
  return lodashGet(config, "custom_ui_labels.specialFeatures", [""]).includes(
    "ENABLE_V3_SEARCH_API"
  );
};
